import { connect } from 'react-redux';
import UserPage from '../components/pages/UserPage';
import {ROUTES} from '../constants';

const mapStateToProps = ({userReducer},ownProps) => {
	return {
		...ownProps,
		fetchingState:userReducer.fetchingState,
		userReducer
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		onClickRecipe : (recipe)=>()=>{
			dispatch({
				type : ROUTES.RECIPE_DETAIL,
				payload : {
					recipeId : recipe.id
				}
			});
		}
	};
};


export default connect(mapStateToProps, mapDispatchToProps)(UserPage);